<button mat-fab fxHide.lg *ngIf="sidenav"><i class="material-icons">menu</i></button>
<ng-content select="[header-icon]"></ng-content>
<h1 class="page-header-title">
    <ng-content></ng-content>
</h1>
<ng-content select="[add-btn]"></ng-content>
